import { render, staticRenderFns } from "./DocumentTemplates.vue?vue&type=template&id=cacb4536"
import script from "./DocumentTemplates.vue?vue&type=script&lang=js"
export * from "./DocumentTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports